import React, { useState, useEffect } from "react";
import Modal from 'react-bootstrap/Modal';
import './manage-group.css';
import { useFormik } from "formik";
import * as Yup from "yup";
import Select from 'react-select';
import { Button } from "../../common/Button";
import { editGroup } from "../../api/Group";
import { failed, success } from "../../common/Toastify";
import { getPatientList, getPractitionerList } from "../../api/Individual";
import moment from "moment";

function AddUser({ modalShow, refreshTable, handleShow, groupId,  groupIsDefault, groupUsersType, existingGroupMembers, orgId=null }) {
    const [userOption, setUserOption] = useState([])
    const [btnLoading, setBtnLoading] = useState(false)

    useEffect(() => {
        if (!orgId) {
            console.warn("Organization ID not selected.");
            return;
        }
    
        const fetchData = async () => {
            try {
                let res;
                if (groupUsersType === "Patient") {
                    res = await getPatientList(orgId);
                } else if (groupUsersType === "Practitioner") {
                    res = await getPractitionerList(orgId);
                }
                const capitalizeFirstLetter = (str) => {
                    return str
                        ?.split(' ')  
                        .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) 
                        .join(' '); 
                }; 
                const userlist = res?.result?.map((user) => ({
                    name: capitalizeFirstLetter(user?.name?.[0]?.text),
                    value: user?.id,
                    type: user?.resourceType,
                    label: capitalizeFirstLetter(user?.name?.[0]?.text) || "Unnamed",
                    id: user?.id,
                })) || []; 

                const existingIds = new Set(
                    existingGroupMembers?.map(member => {
                        const ref = member?.entity?.reference;
                        return ref?.split("/")?.[1];  
                    })
                ); 
                const filteredList = userlist.filter(user => !existingIds.has(user.id));  
                setUserOption(filteredList);
            } catch (err) {
                console.error("Error fetching list:", err);
            }
        };
    
        fetchData();  
    }, [modalShow, orgId, groupUsersType]);
    

    const formik = useFormik({
        initialValues: {
            member: [],
        },
        validationSchema: Yup.object({
            member: Yup.array().min(1, "At least one member is required"),
        }),
        onSubmit: (values) => {
            setBtnLoading(true); 
            const allMembers = [
                ...existingGroupMembers,
                ...values.member.map(item => ({
                    entity: {
                        display: item?.name,
                        reference: `${item?.type}/${item?.id}`,
                        type: item?.type
                    },
                    period: {
                        start: moment().utc().format("YYYY-MM-DDTHH:mm:ss[Z]"),
                        end: null
                    },
                    inactive: false
                }))
            ];
        
            editGroup({
                groupId,
                member: allMembers,
                quantity: allMembers.length,
                orgId: orgId
            })
                .then((res) => {
                    refreshTable();
                    handleShow();
                    success("Users added!");
                })
                .catch((err) => failed(err?.response?.data?.message || err.message))
                .finally(() => setBtnLoading(false));
        },
    });
    return (
        <Modal
            show={modalShow}
            onHide={handleShow}
            size="md"
            aria-labelledby="contained-modal-title-vcenter"
            centered className="custom-dialog"
            backdropClassName
            backdrop={'static'}
        >
            <Modal.Header closeButton className="border-0">
                <Modal.Title id="contained-modal-title-vcenter">
                    Add Users
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <form className="common-form" onSubmit={formik.handleSubmit}>
                    <div className="field-wrap">
                        <label>Select Users</label>
                        <Select
                            onChange={(data) => formik.setFieldValue("member", data)}
                            isMulti
                            name="userIds"
                            options={userOption}
                            className="basic-multi-select"
                            classNamePrefix="select"
                            autoFocus
                        />
                        <div>{formik?.touched["member"] && formik?.errors["member"] ? <div className="error-text">{formik?.errors["member"]}</div> : null}</div>
                    </div>
                    <div className="btn-wrap" style={{ display: 'flex' }}>
                        <Button className="margin-10" variant="secondary" onClick={handleShow} title="Cancel">Cancel</Button>
                        <Button type="submit" isLoading={btnLoading}>Add Users</Button>
                    </div>
                </form>
            </Modal.Body>
        </Modal>
    );
}


export default AddUser
